import { render } from "./PackingList.vue?vue&type=template&id=05bd3ad4&scoped=true"
import script from "./PackingList.vue?vue&type=script&lang=js"
export * from "./PackingList.vue?vue&type=script&lang=js"

import "./PackingList.vue?vue&type=style&index=0&id=05bd3ad4&lang=css"
import "./PackingList.vue?vue&type=style&index=1&id=05bd3ad4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bd3ad4"]])

export default __exports__